import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { EventDTO } from 'src/app/api/models/events-dto';
import { ExportPayload } from 'src/app/api/models/shared-dto';
import { ShowcaseDetailProduct } from 'src/app/api/models/showcases-dto';
import { AllocationSearchParams, AllocationSelectOption, MoveProductsPayload, ProductTrayDTO, RemoveProductsPayload, TrayDTO } from 'src/app/api/models/trays-dto';
import { AllocationService, LookupService } from 'src/app/api/services';
import { SignalRService } from 'src/app/api/services/signal-r.service';
import { TraysService } from 'src/app/api/services/trays.service';
import { FILTER_TYPE } from 'src/app/enums/filters.constants';
import { TAB } from 'src/app/enums/products.constants';
import { RoleEnum } from 'src/app/enums/role-enum';
import { ExportFormat, ExportType, Section } from 'src/app/enums/shared.enum';
import { FileExportPayload } from 'src/app/enums/shared.type';
import { SharedService } from 'src/app/services/shared.service';
import { ShowcasePictureDialogComponent } from '../dialogs/showcase-picture-dialog/showcase-picture-dialog.component';
import { ShowcaseDetailComponent } from '../showcase-detail/showcase-detail.component';
import { TrayDetailComponent } from './tray-detail/tray-detail.component';

@Component({
  selector: 'app-product-allocation',
  templateUrl: './product-allocation.component.html',
  styleUrls: ['./product-allocation.component.scss']
})
export class ProductAllocationComponent implements OnInit, OnDestroy {
  //TODO: Implementare la logica secondo la quale quando si modifica uno showcsae/tray/extratray occorre salvarsi le modifiche in locale e non effettuare di nuovo la get all dei dati

  @Input() createNewTrayFlag$!: BehaviorSubject<boolean>;
  @Input() export$!: BehaviorSubject<ExportPayload>;

  @Input() allocationType!: TAB.SHOWCASE | TAB.TRAY | TAB.EXTRA_TRAY;
  @Input() refreshTrays$!: BehaviorSubject<boolean>;

  private readonly LIMIT = 12;
  private readonly FREE_PRODUCT_TRAY_ID = -1;
  private readonly INITIAL_PARAMETERS: AllocationSearchParams = {
    Limit: this.LIMIT,
    Skip: 0
  }

  protected readonly BASKET = TAB.BASKET;

  private createNewTrayFlagSubscription: Subscription = new Subscription();
  private exportSubscription: Subscription = new Subscription();
  private refreshTraysSubscription: Subscription = new Subscription();
  private freeProductsTray: TrayDTO = { code: "FREE PRODUCTS", id: this.FREE_PRODUCT_TRAY_ID, products: [], showCases: [] };
  private event?: EventDTO;
  private basket: ShowcaseDetailProduct[] = [];
  private trays: TrayDTO[] = [];

  protected highlightedProducts: string = "";
  protected loadingFreeProducts: boolean = false;
  protected createNewTrayFlag: boolean = false;
  protected selectedProducts: string[] = [];
  // protected selectOptions: AllocationSelectOption[] = [];
  protected selectOptions: {
    commonOptions: AllocationSelectOption[],
    showcases: AllocationSelectOption[]
  } = {
      commonOptions: [],
      showcases: []
    }
  protected showPictureDialogSubscription?: Subscription;
  protected loadingFiltersOptions: string[] = [];
  protected downloadProgress: any;
  protected collapsedBasket: boolean = false;
  protected initialDate?: any;
  protected parameters: AllocationSearchParams = { ...this.INITIAL_PARAMETERS };
  protected scrolling: boolean = false;
  protected loading: boolean = false;
  protected count: number = 0;


  constructor(
    public traysService: TraysService,
    public sharedService: SharedService,
    public lookupService: LookupService,
    public translateService: TranslateService,
    public allocationService: AllocationService,
    private dialog: MatDialog,
    private signalR: SignalRService,
    private readonly changeDedectionRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.event = this.sharedService.event;
    // Se mi trovo in EXTRA TRAY devo preimpostare la "referenceDate" in fase di montaggio della product allocation
    if (this.traysService.isExtraTrayAllocation(this.allocationType)) {
      this.setInitialDate();
    }
    this.loadAllocation();
    this.loadAllocationOptions();

    this.createNewTrayFlagSubscription = this.createNewTrayFlag$.subscribe(flag => this.createNewTrayFlag = flag);
    this.exportSubscription = this.export$.subscribe(exportPayload => {
      if (exportPayload.type !== ExportType.none) {
        this.exportFile(exportPayload.type === ExportType.ppt, exportPayload.withImages);
      }
    });

    //Dopo aver effettuato l'upload devo refreshare tutto
    this.refreshTraysSubscription = this.refreshTrays$.subscribe(flag => {
      if (flag) {
        // this.reset();
        // this.loadAllocation();
        this.loadAllocationOptions();
      }
    })

    //Se modifico l'allocazione di uno showcase con un immagine associata, devo avvisare l'utente della cancellazione dell'immagine
    this.showPictureDialogSubscription = this.traysService.showShowcasePictureDialog$.subscribe(res => {
      if (res) {
        this.openShowcasePictureDialog();
      }
    })
  }

  ngOnDestroy(): void {
    this.createNewTrayFlagSubscription?.unsubscribe()
    if (this.exportSubscription) {
      this.export$.next({ type: ExportType.none } as ExportPayload);
      this.exportSubscription.unsubscribe()
    }
    this.refreshTraysSubscription?.unsubscribe();
    if (this.showPictureDialogSubscription) {
      this.showPictureDialogSubscription.unsubscribe();
    }
  }

  setInitialDate() {
    this.parameters.ReferenceDate = moment(this.sharedService.getDayInEventRange(new Date(), true));
    //!OLD
    // return;
    // let event = this.sharedService.event;
    // let eventInitDate = moment(event.initDate);
    // let eventEndDate = moment(event.endDate);
    // let today = moment();
    // let isTodayDuringTheEvent = today.isAfter(eventInitDate.startOf('d')) && today.isBefore(eventEndDate.endOf('d'));
    // if (isTodayDuringTheEvent) {
    //   this.initialDate = today;
    // } else {
    //   this.initialDate = eventInitDate;
    // }
    // // this.parameters.ReferenceDate = moment("2024-04-11")
    // this.parameters.ReferenceDate = this.initialDate;
  }

  setTrays(trays: TrayDTO[]) {
    //Se sto caricando altri vassoi tramite scroll allora devo concatenare i vassoi della response con quelli precaricati
    if (this.scrolling) {
      trays = this.trays.concat(trays);
    }
    this.trays = trays;
  }

  getTrays() {
    return this.trays;
  }

  setFreeProductsTray(trays: ProductTrayDTO[]) {
    this.freeProductsTray.products = trays;
  }

  getFreeProductsTray() {
    return this.freeProductsTray;
  }

  loadAllocation(callback?: Function, avoidPagination?: boolean) {
    switch (true) {
      case this.traysService.isTrayAllocation(this.allocationType):
      case this.traysService.isExtraTrayAllocation(this.allocationType): {
        this.loadTraysAllocation(callback, avoidPagination);
        break;
      }
      case this.traysService.isShowcaseAllocation(this.allocationType): {
        this.loadShowcasesAllocation(callback, avoidPagination);
        break;
      }
    }
  }

  loadShowcasesAllocation(callback?: Function, avoidPagination?: boolean) {
    if (this.event) {
      this.loading = true;
      let parameters = { ...this.parameters };
      if (avoidPagination) {
        parameters.Limit = (parameters.Skip ?? 0) + (parameters.Limit ?? 0);
        delete parameters.Skip;
      }
      this.allocationService.getShowcases(this.event?.id, parameters).subscribe(
        (res) => {
          this.count = res.count;
          if (res.nextSkip === null) {
            //Blocco l'infinite scroll quando ho caricato tutti i vassoi
            // delete this.parameters.Skip;
            this.parameters.Skip = undefined;
            // delete this.parameters.Limit;
            this.parameters.Limit = this.count;
          }
          let showcases = res.items.map((item: any) => this.parseToShowcase(item));
          this.setTrays(showcases);
          if (callback) {
            callback()
          }
          this.loading = false;
          this.scrolling = false;
          this.highlightAllProducts()
        },
        (err) => {
          this.loading = false;
          this.scrolling = false;
          this.openSnackBar();
        });

    }
  }

  loadTraysAllocation(callback?: Function, avoidPagination?: boolean) {
    if (this.event) {
      this.loading = true;
      let parameters = { ...this.parameters };
      if (avoidPagination) {
        parameters.Limit = (parameters.Skip ?? 0) + (parameters.Limit ?? 0);
        delete parameters.Skip;
      }
      this.traysService.getTraysList(this.event?.id, parameters, this.traysService.isExtraTrayAllocation(this.allocationType)).subscribe(
        (res) => {
          this.count = res.count;
          if (res.nextSkip === null) {
            //Blocco l'infinite scroll quando ho caricato tutti i vassoi
            // delete this.parameters.Skip;
            this.parameters.Skip = undefined;
            // delete this.parameters.Limit;
            this.parameters.Limit = this.count;
          }
          this.setTrays(res.items);
          if (callback) {
            callback()
          }
          this.loading = false;
          this.scrolling = false;
          this.highlightAllProducts()
        },
        (err) => {
          this.loading = false;
          this.scrolling = false;
          this.openSnackBar();
        });

      if (!this.scrolling) {
        this.loadingFreeProducts = true;
        let params: AllocationSearchParams = { ...this.parameters };
        // delete params.Limit;
        params.Limit = -1;
        delete params.Skip;

        this.traysService.getFreeProductsList(this.event?.id, params, this.traysService.isExtraTrayAllocation(this.allocationType)).subscribe(
          (res) => {
            this.setFreeProductsTray(res.items);
            this.loadingFreeProducts = false;
            this.highlightAllProducts()
          },
          (err) => {
            this.loadingFreeProducts = false;
            this.openSnackBar();
          });
      }
    }
  }

  moveProducts(payload: MoveProductsPayload, callback?: Function) {
    if (this.event) {
      const { idTray, sapCodes } = payload;
      switch (true) {
        case this.traysService.isShowcaseAllocation(this.allocationType): {
          this.loading = true;
          this.allocationService.putAddProductsResponse(this.event.id, sapCodes, idTray?.toString()).subscribe(
            (res) => {

              if (this.traysService.isShowcaseAllocation(this.allocationType)) {
                const removedProducts = this.basket.filter(product => this.selectedProducts.includes(product.sapCode));
                this.checkShowcaseHasPicture(removedProducts, (payload.idTray as string))
              }

              this.loadAllocation(callback, true);
              this.openSnackBar('moved');
            },
            (err) => {
              this.loading = false;
              this.openSnackBar();
            },
          )
          break;
        }
        case this.traysService.isTrayAllocation(this.allocationType):
        case this.traysService.isExtraTrayAllocation(this.allocationType): {
          //Controllo se il tray di destinazione è quello dei FREE PRODUCTS
          if (String(idTray) === String(this.FREE_PRODUCT_TRAY_ID)) {
            /**
             * Se sto droppando dei prodotti nel FREE PRODUCTS TRAY sto effettivamente
             * effettuando una rimozione dei prodotti, quindi andrò ad invocare il metodo
             * "removeProducts" che comunque sposterà i prodotti nel FREE PRODUCTS TRAY
             */
            this.removeProducts(payload, callback);
          } else {
            this.loading = true;
            this.traysService.moveProductsInTray(this.event.id, idTray, sapCodes, this.traysService.isExtraTrayAllocation(this.allocationType)).subscribe(
              (res) => {
                this.loadAllocation(callback, true);
                this.openSnackBar('moved');
              },
              (err) => {
                this.loading = false;
                this.openSnackBar();
              },
            )
          }
          break;
        }
      }

    }
  }

  search(event?: any) {
    if (event) {
      this.parameters = { ...this.INITIAL_PARAMETERS };
      this.parameters.Search = event.search;
      this.parameters.SapCodes = event.sapCodes;
      if (this.traysService.isShowcaseAllocation(this.allocationType)) {
        this.parameters.ShowCases = event.showcases?.map((t: TrayDTO) => t.code);
        if ("hasImage" in event) {
          this.parameters.HasImage = event.hasImage;
        }
        if ("productStatus" in event) {
          this.parameters.ProductStatus = event.productStatus;
        }
      } else {
        this.parameters.Trays = event.trays?.map((t: TrayDTO) => t.code);
        this.parameters.ShowcaseCodes = event.showcases?.map((t: any) => t.code);
        if ("hasBookedForSale" in event) {
          this.parameters.hasBookedForSale = event.hasBookedForSale;
        }
      }
      if (event?.referenceDate) {
        this.parameters.ReferenceDate = moment(event.referenceDate);
      }
    }
    this.loadAllocation();
    this.loadAllocationOptions()
  }

  reset() {
    this.parameters = { ...this.INITIAL_PARAMETERS };
    // if (this.traysService.isExtraTrayAllocation(this.allocationType)) {
    //   this.setInitialDate();
    // }
    this.loadAllocation();
  }

  openSnackBar(status?: string) {
    switch (status) {
      case 'moved': {
        this.sharedService.openSnackBar(this.t(`SWAP_AREA.PRODUCT_MOVEMENT.${this.allocationType}`), false);
        break;
      }
      default: {
        this.sharedService.openSnackBar(this.t("ERROR_GENERIC_RETRY"), true);
        break;
      }
    }
  }

  t(text: string) {
    return this.translateService.instant(text);
  }

  loadAllocationOptions() {
    if (this.event) {
      if (this.traysService.isShowcaseAllocation(this.allocationType)) {
        this.loadingFiltersOptions.push("showCaseControl");
        this.lookupService.getShowcases(this.event.id).subscribe(
          (res) => {
            this.selectOptions = {
              ...this.selectOptions,
              showcases: this.parseShowcaseOptions(res)
            }
            this.changeDedectionRef.detectChanges();
            this.loadingFiltersOptions = this.loadingFiltersOptions.filter(field => field !== "showCaseControl");
          },
          (err) => {
            this.openSnackBar();
            this.loadingFiltersOptions = this.loadingFiltersOptions.filter(field => field !== "showCaseControl");
          },
        )
      } else {
        this.loadExtraTraysOptions();

        this.loadingFiltersOptions.push("showCaseControl");
        this.lookupService.getShowcases(this.event.id).subscribe(
          (res) => {
            this.selectOptions = {
              ...this.selectOptions,
              showcases: this.parseShowcaseOptions(res)
            }
            this.changeDedectionRef.detectChanges();
            this.loadingFiltersOptions = this.loadingFiltersOptions.filter(field => field !== "showCaseControl");

          },
          (err) => {
            this.openSnackBar();
            this.loadingFiltersOptions = this.loadingFiltersOptions.filter(field => field !== "showCaseControl");
          },
        )
      }
    }
  }

  loadExtraTraysOptions() {
    if (this.event) {
      this.loadingFiltersOptions.push("trayControl");
      this.lookupService.getTrays(this.event.id, this.parameters.ReferenceDate, this.traysService.isExtraTrayAllocation(this.allocationType)).subscribe(
        (res) => {
          res.push(this.freeProductsTray);
          this.selectOptions = {
            ...this.selectOptions,
            commonOptions: this.parseOptions(res)
          }
          this.changeDedectionRef.detectChanges();
          this.loadingFiltersOptions = [...this.loadingFiltersOptions.filter(field => field !== "trayControl")];
        },
        (err) => {
          this.openSnackBar();
          this.loadingFiltersOptions = [...this.loadingFiltersOptions.filter(field => field !== "trayControl")];
        },
      );
    }
  }

  handleCloseDrawer(isShowcaseCreated?: boolean) {
    if (isShowcaseCreated) {
      // this.reset();
      this.loadAllocationOptions();
      this.loadAllocation();
    }
    this.createNewTrayFlag$.next(false);
  }

  openDetail(args: { tray: TrayDTO, toClone?: boolean }) {
    const { tray, toClone } = args;
    switch (true) {
      case this.traysService.isTrayAllocation(this.allocationType):
      case this.traysService.isExtraTrayAllocation(this.allocationType): {
        this.openTrayDetail(tray, toClone);
        break;
      }
      case this.traysService.isShowcaseAllocation(this.allocationType): {
        this.openShowcaseDetail(tray);
        break;
      }
    }
  }

  openTrayDetail(tray: TrayDTO, toClone?: boolean) {
    if (tray) {
      let clone = { ...tray };
      const copyLabel = " - COPY";
      const oldCode = tray.code;
      if (toClone) {
        clone.code += copyLabel;
        clone.location = '';
      }
      const dialogRef = this.dialog.open(TrayDetailComponent, {
        data: {
          eventId: this.event?.id,
          isExtraTrayAllocation: this.traysService.isExtraTrayAllocation(this.allocationType),
          tray: clone,
          oldCode,
          toClone
        },
        hasBackdrop: true,
        panelClass: ['tray-dialog'],
        backdropClass: 'bdrop'
      });
      dialogRef.afterClosed().subscribe(edited => {
        // this.handleCloseDrawer(edited);
        if (edited) {
          // this.reset();
          this.loadAllocation(() => { }, true)
          //Aggiorno anche le options
          this.loadAllocationOptions();
        }
      });
    }
  }

  openShowcaseDetail(showcase: TrayDTO) {
    if (showcase && showcase.id) {
      const dialogRef = this.dialog.open(ShowcaseDetailComponent, {
        data: {
          eventId: this.event?.id,
          showcaseId: showcase.id,
        },
        width: '80vw',
        height: '80vh',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(edited => {
        // this.handleCloseDrawer(edited);
        if (edited) {
          // this.reset()
          this.loadAllocation(() => { }, true)
        }
      });
    }
  }

  getCloneCounter(code: string) {
    let counter = 0;
    this.trays.forEach(t => {
      if (t.code === code) {
        counter++;
      }
    });

    return counter;
  }

  onScroll(event: any) {
    if (this.scrolling || this.loading) {
      return;
    }
    const { scrollHeight, scrollTop, clientHeight } = event.target;
    if (Math.abs(scrollHeight - clientHeight - scrollTop) < 200) {
      if (typeof this.parameters.Skip === "number") {
        //Se non è number vuol dire che è null e quindi abbiamo caricato tutti i vassoi
        if (this.parameters.Skip < this.count) {
          this.parameters.Skip += this.LIMIT;
          this.loadOtherAllocations();
        }
      } else if (this.parameters.Skip === 0) {
        //La prima volta setto Skip a LIMIT
        this.parameters.Skip = this.LIMIT;
        this.loadOtherAllocations();
      }
    }
  }

  loadOtherAllocations() {
    this.scrolling = true;
    this.loadAllocation();
  }

  canShowFreeProductsTray() {
    if (this.traysService.isShowcaseAllocation(this.allocationType)) {
      return false;
    }
    let show = true;
    // if (Array.isArray(this.parameters.Trays) && this.parameters.Trays.length > 0 && !(this.parameters.Trays.includes(this.freeProductsTray.code))) {
    //   show = false;
    // }
    return show && !this.loading;
  }

  removeProducts(payload: RemoveProductsPayload, callback?: Function) {
    let { sapCodes, idExtraTray } = payload;
    if (this.event) {
      switch (true) {
        case this.traysService.isShowcaseAllocation(this.allocationType): {
          this.allocationService.deleteAllocationProduct(this.event.id, sapCodes[0]).subscribe(
            (res) => {
              this.loadAllocation(() => { }, true);
              if (callback) {
                callback()
              }
            },
            (err) => {
              this.loading = false;
              this.openSnackBar();
            },
          )
          break;
        }
        case this.traysService.isTrayAllocation(this.allocationType):
        case this.traysService.isExtraTrayAllocation(this.allocationType): {
          this.loading = true;
          this.loadingFreeProducts = true;
          this.traysService.deleteProducts(this.event.id, sapCodes, this.traysService.isExtraTrayAllocation(this.allocationType), idExtraTray).subscribe(
            (res) => {
              this.loadAllocation(() => { }, true);
              if (callback) {
                callback()
              }
            },
            (err) => {
              this.loading = false;
              this.loadingFreeProducts = false;
              this.openSnackBar();
            },
          )
          break;
        }
      }
    }
  }

  handleSelectProduct(product: ShowcaseDetailProduct) {
    if (!this.isInBasket(product.sapCode)) {
      this.basket.push(product);
    }
    if (!this.collapsedBasket) {
      this.collapsedBasket = true;
    }
  }

  getBasketItems() {
    return this.basket;
  }

  getBasketSapCodes() {
    return this.basket.map(p => p.sapCode);
  }

  getBasketItemsCount() {
    let count = this.getBasketItems().length;
    if (count > 0) {
      return `(${count})`
    } else {
      return '';
    }
  }

  // showSelectAllCta() {
  //   return this.getBasketItems().length > 0 && this.selectedProducts.length !== this.getBasketItems().length
  // }

  // showDeselectAllCta() {
  //   return this.getBasketItems().length > 0  && this.selectedProducts.length === this.getBasketItems().length;
  // }

  removeAllProductsFromBasket() {
    this.basket = [];
    this.selectedProducts = [];
  }

  removeProductFromBasket(event: string[]) {
    let index = this.basket.findIndex(p => p.sapCode === event[0]);
    if (index >= 0) {
      let product = this.basket.splice(index, 1)[0];
      this.selectedProducts = this.selectedProducts.filter(code => code !== product.sapCode);
    }
  }

  selectProductInBasket(product: ShowcaseDetailProduct) {
    let sapCode = product.sapCode;
    if (!(this.selectedProducts.includes(sapCode))) {
      this.selectedProducts.push(sapCode);
    } else {
      this.selectedProducts = this.selectedProducts.filter(code => code !== sapCode);
    }
  }

  selectAllProductsInBasket(deselect?: boolean) {
    if (deselect) {
      this.selectedProducts = [];
    } else {
      this.selectedProducts = this.basket.map(p => p.sapCode);
    }
  }

  isInBasket(sapCode: string) {
    return this.getBasketSapCodes().includes(sapCode);
  }

  isSelectedProduct(sapCode: string) {
    return this.selectedProducts.includes(sapCode);
  }

  moveProductsFromBasket(idTray: number | string) {
    if (this.selectedProducts.length > 0) {
      const payload = {
        idTray: idTray,
        sapCodes: this.selectedProducts
      };
      this.moveProducts(payload, () => this.restoreBasket())
    }
  }

  restoreBasket() {
    let remainingProducts: ShowcaseDetailProduct[] = [];
    let removedProducts: ShowcaseDetailProduct[] = [];
    this.basket.forEach(product => {
      if (this.selectedProducts.includes(product.sapCode)) {
        removedProducts.push(product);
      } else {
        remainingProducts.push(product);
      }
    })
    // if (this.traysService.isShowcaseAllocation(this.allocationType)) {
    //   this.checkShowcaseHasPicture(removedProducts, (allocationIdOfDestination as string))
    // }
    this.basket = remainingProducts;
    this.selectedProducts = [];
    if (this.basket.length === 0 && this.collapsedBasket) {
      this.collapsedBasket = false;
    }

  }

  showEmptyPlaceholder() {
    return !this.loading && this.getTrays().length === 0;
  }

  getFilterType() {
    switch (true) {
      case this.traysService.isTrayAllocation(this.allocationType): return FILTER_TYPE.TRAYS;
      case this.traysService.isExtraTrayAllocation(this.allocationType): return FILTER_TYPE.EXTRA_TRAYS;
      case this.traysService.isShowcaseAllocation(this.allocationType): return FILTER_TYPE.ALLOCATION;
      default: return "";
    }
  }

  getDrawerTitle() {
    let key = '';
    switch (true) {
      case this.traysService.isTrayAllocation(this.allocationType): {
        key = 'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.TITLE'
        break;
      };
      case this.traysService.isExtraTrayAllocation(this.allocationType): {
        key = 'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.TITLE2'
        break;
      };
      case this.traysService.isShowcaseAllocation(this.allocationType): {
        key = 'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.TITLE'
        break;
      };
      default: return "";
    }
    return this.translateService.instant(key);
  }

  parseToShowcase(value: any) {
    let products = [];
    if (value.products) {
      products = value.products.map((p: any) => {
        return {
          ...p,
          status: p.status
        }
      });
    }
    let id = value.showcaseId || -1;
    if (this.traysService.isShowcaseAllocation(this.allocationType)) {
      id = value.showcaseId;
    }
    let parsed: TrayDTO = {
      code: value.showcaseCode,
      showcaseDescription: value.showcaseDescription,
      id: id,
      products: products,
      showCases: [],
      image: value.image || null,
    }
    return parsed;
  }

  parseOptions(items: any[]) {
    return items.map(el => {
      return {
        code: el.code || "",
        description: el.code || ""
      }
    })
  }

  parseShowcaseOptions(items: any[]) {
    if (items.length > 0 && this.traysService.isShowcaseAllocation(this.allocationType)) {
      items.push({
        code: '',
        area: undefined,
        floor: undefined,
        id: undefined,
        occupability: undefined,
        availability: undefined,
        description: this.translateService.instant('PAGES.ALLOCATION.NOT_ALLOCATED')
      })
    }
    return items.map(el => {
      let description = el.description;
      if (el.area) {
        description = el.description + " - " + el.area;
      }
      return {
        code: el.code || "",
        description: description
      }
    })
  }

  /**
  * Questo metodo consente di aggiornare gli showcase di provenienta e destinazione dopo l'allocazione di un prodotto.
  * Perché devono essere aggiornati?
  * Perché se si modifica l'allocazione di una vetrina per cui è stata già caricata una foto, occorre avvisare l'utente
  * che la foto verrà eliminata e conseguentemente occorrerà aggiornare tutti le vetrine in gioco modificando il falg "image" a false.
  * @param products - Elenco dei prodotti che vengono spostati
  * @param showCaseCode - Codice dello showcase in cui vengono spostati
  */
  checkShowcaseHasPicture(products: ShowcaseDetailProduct[], showcaseCode: string) {
    //Ottengo tutti gli showcaseCode dei prodotti della/e vetrina/e di provenienza
    let showcaseCodesToUpdate = products.map(p => p.prevAllocationCode);
    //Aggiungo lo showcaseCode della vetrina di destinazione
    showcaseCodesToUpdate.push(showcaseCode);
    //Elimino i duplicati
    let uniques = new Set(showcaseCodesToUpdate);
    let needToShowTheShowcasePictureDialog = false;
    let i = 0;
    do {
      if (uniques.has(this.trays[i].code) && this.trays[i].image) {
        //Setto a true il flag che mi mostrerà, una sola volta, la modale che mi avvisa della cancellazione delle imamgini
        needToShowTheShowcasePictureDialog = true;
      }
      i++;
    } while (i < this.trays.length && !needToShowTheShowcasePictureDialog);

    if (needToShowTheShowcasePictureDialog) {
      this.traysService.showShowcasePictureDialog$.next(true);
    }
  }

  openShowcasePictureDialog() {
    this.dialog.open(ShowcasePictureDialogComponent, {
      data: {},
      hasBackdrop: true,
      panelClass: ['showcase-picture-dialog'],
      backdropClass: 'bdrop'
    });
  }

  highlightAllProducts() {
    if (this.parameters.SapCodes) {
      this.highlightedProducts = this.parameters.SapCodes;
    } else {
      this.highlightedProducts = "";
    }
  }


  isReadOnlyView() {
    const isLogisticReadOnly = this.sharedService.isUserRole(RoleEnum.LOGISTIC_READONLY);
    return isLogisticReadOnly
  }

  showFreeProductsCounter() {
    return !this.loadingFreeProducts && this.traysService.isGenerallyTrayAllocation(this.allocationType);
  }

  getFreeProductsCounter() {
    return this.freeProductsTray.products ? this.freeProductsTray.products?.length : 0;
  }

  exportFile(ppt?: boolean, withImages?: boolean) {
    this.signalR.startExportNotificationsConnection().subscribe(() => {
      this.signalR.onExportProgressUpdated().subscribe(
        (message) => {
          try {
            const payload = message.data;
            if (payload.status === 1) {
              this.signalR.stopExportNotificationsConnection()
              setTimeout(() => {
                this.downloadProgress = undefined;
                // this.signalR.stopExportNotificationsConnection()
              }, 500);
            } else {
              this.downloadProgress = Number(payload.progress.toFixed());
            }
          }
          catch (err) {
            console.log(err);
            this.downloadProgress = undefined;
          }
        });
    });

    if (this.traysService.isShowcaseAllocation(this.allocationType)) {
      this.exportShowcases(ppt, withImages);
    }

    if (this.traysService.isGenerallyTrayAllocation(this.allocationType)) {
      this.exportTrays(ppt)
    }

  }

  exportShowcases(ppt?: boolean, withImages?: boolean) {
    if (this.event) {
      this.loading = true;
      let { ShowCases } = this.parameters;
      let payload: FileExportPayload = {
        format: ppt ? ExportFormat.PPT : ExportFormat.XLSX,
        section: Section.Allocation,
        event: this.event,
        parameters: { ShowCases, withImages }
      }
      this.sharedService.fileExport(payload,
        () => this.loading = false,
        () => {
          this.loading = false;
          this.downloadProgress = undefined;
        });


      // this.allocationService.getExport(this.event.id, { ShowCases }, ppt, withImages).subscribe(res => {
      //   this.loading = false;
      //   const timeLabel = moment(new Date()).format('MM_DD_YYYY_HH_mm_ss');
      //   const fileName = this.translateService.instant('PAGES.ALLOCATION.TITLE') + '_' + this.event?.title.trim() + '_' + timeLabel;
      //   if (ppt) {
      //     let url = res.replaceAll('"', '');
      //     this.sharedService.downloadFromUrl(url, fileName);
      //     // this.sharedService.downloadFromUrl(res, fileName);
      //   } else {
      //     this.sharedService.saveFile(res, fileName);
      //   }
      // }, err => {
      //   console.error(err);
      //   this.loading = false;
      //   this.downloadProgress = undefined;
      //   this.sharedService.openSnackBar(this.translateService.instant(this.translateService.instant('ERROR_GENERIC_RETRY')), true);
      // });
    }
  }

  exportTrays(ppt?: boolean) {
    if (this.event) {
      this.loading = true
      // let exportObserver = new Observable();
      // let title = '';
      const {
        Trays,
        ReferenceDate,
        Search,
        SapCodes,
        ShowcaseCodes,
      } = this.parameters;
      let params: any = { Trays };
      let payload: FileExportPayload = {
        format: ppt ? ExportFormat.PPT : ExportFormat.XLSX,
        section: this.traysService.isTrayAllocation(this.allocationType) ? Section.Tray : Section.ExtraTrays,
        event: this.event,
      }
      if (this.traysService.isTrayAllocation(this.allocationType)) {
        let date = ReferenceDate;
        if (ppt && !ReferenceDate) {
          let eventInitDate = moment(this.sharedService.getMinDateEvent(true));
          let eventEndDate = moment(this.sharedService.getMaxDateEvent(true));
          let today = moment();
          let isTodayDuringTheEvent = today.isAfter(eventInitDate.startOf('d')) && today.isBefore(eventEndDate.endOf('d'));
          if (isTodayDuringTheEvent) {
            date = today;
          } else {
            if (today.isAfter(eventEndDate.endOf('d'))) {
              date = eventEndDate;
            }
            if (today.isBefore(eventInitDate.startOf('d'))) {
              date = eventInitDate;
            }
          }
          params.ReferenceDate = date;
        }
        // exportObserver = this.traysService.export(this.event.id, { Trays, ReferenceDate: date }, ppt);
      }
      params.ReferenceDate = ReferenceDate;
      params.Search = Search;
      params.SapCodes = SapCodes;
      params.ShowcaseCodes = ShowcaseCodes;
      // if (this.traysService.isExtraTrayAllocation(this.allocationType)) {
      //   exportObserver = this.traysService.export(this.event.id, { Trays }, ppt, true);
      // }
      payload.parameters = params;

      this.sharedService.fileExport(payload,
        () => this.loading = false,
        () => {
          this.loading = false;
          this.downloadProgress = undefined;
        });
      // exportObserver.subscribe((res: any) => {
      //   this.loading = false;
      //   const timeLabel = moment(new Date()).format('MM_DD_YYYY_HH_mm_ss');
      //   const fileName = this.translateService.instant(title) + '_' + this.event?.title.trim() + '_' + timeLabel;
      //   this.sharedService.saveFile(res, fileName);
      // }, err => {
      //   console.error(err);
      //   this.loading = false;
      //   this.downloadProgress = undefined;
      //   this.sharedService.openSnackBar(this.translateService.instant(this.translateService.instant('ERROR_GENERIC_RETRY')), true);
      // });
    }
  }

  handleFiltersChange(values: any) {
    let { dateFormControl } = values;
    // let isDifferentDate = !(moment(dateFormControl).isSame(moment(this.parameters.ReferenceDate), 'day'));
    let isDifferentDate = moment(dateFormControl).format('DD/MM/YYYY') !== moment(this.parameters.ReferenceDate).format('DD/MM/YYYY')
    if (isDifferentDate) {
      this.parameters.ReferenceDate = dateFormControl ? moment(dateFormControl) : null;
      this.loadExtraTraysOptions();
    }
  }
}
